import { TrackingCategory, TrackingContext } from '@ps/web-shared-analytics';
import React from 'react';

import { getDisplayName } from '@swf/core/utils';

import BonusOffer from '../BonusOffer/BonusOffer';
import SignupOffer from '../Signup/components/SignupOffer/SignupOffer';
import WizardGroup from '../WizardGroup/WizardGroup';

import RMFAccumulatedBuyInLimit from './components/RMFAccumulatedBuyInLimit/RMFAccumulatedBuyInLimit';
import RMFAddress from './components/RMFAddress/RMFAddress';
import RMFAutomaticWithdrawalLimit from './components/RMFAutomaticWithdrawalLimit/RMFAutomaticWithdrawalLimit';
import RMFBankDetails from './components/RMFBankDetails/RMFBankDetails';
import RMFCitizenship from './components/RMFCitizenship/RMFCitizenship';
import RMFCompleted from './components/RMFCompleted/RMFCompleted';
import RMFCompletedDK from './components/RMFCompleted/components/RMFCompletedDK/RMFCompletedDK';
import RMFCrossOperatorDepositLimit from './components/RMFCrossOperatorDepositLimit/RMFCrossOperatorDepositLimit';
import RMFDOB from './components/RMFDOB/RMFDOB';
import RMFDepositLimit from './components/RMFDepositLimit/RMFDepositLimit';
import RMFDocumentation from './components/RMFDocumentation/RMFDocumentation';
import RMFEKYCSuccess from './components/RMFEKYCSuccess/RMFEKYCSuccess';
import RMFFiscalCode from './components/RMFFiscalCode/RMFFiscalCode';
import RMFGender from './components/RMFGender/RMFGender';
import RMFIdentityVerification from './components/RMFIdentityVerification/RMFIdentityVerification';
import RMFKBA from './components/RMFKBA/RMFKBA';
import RMFLegalName from './components/RMFLegalName/RMFLegalName';
import RMFLossLimit from './components/RMFLossLimit/RMFLossLimit';
import RMFOccupation from './components/RMFOccupation/RMFOccupation';
import RMFOccupationPEP from './components/RMFOccupationPEP/RMFOccupationPEP';
import RMFPendingVerification from './components/RMFPendingVerification/RMFPendingVerification';
import RMFPhone from './components/RMFPhone/RMFPhone';
import RMFPhoneVerification from './components/RMFPhoneVerification/RMFPhoneVerification';
import RMFPlaceOfBirth from './components/RMFPlaceOfBirth/RMFPlaceOfBirth';
import RMFPlayerFundsProtection from './components/RMFPlayerFundsProtection/RMFPlayerFundsProtection';
import RMFPlayingTimeLimit from './components/RMFPlayingTimeLimit/RMFPlayingTimeLimit';
import RMFPokerTimeLimit from './components/RMFPokerTimeLimit/RMFPokerTimeLimit';
import RMFResult from './components/RMFResult/RMFResult';
import RMFSSN from './components/RMFSSN/RMFSSN';
import RMFSSNConfirmation from './components/RMFSSN/components/RMFSSNConfirmation/RMFSSNConfirmation';
import RMFSecurityQuestions from './components/RMFSecurityQuestions/RMFSecurityQuestions';
import RMFStandaloneFinalPage from './components/RMFStandaloneFinalPage/RMFStandaloneFinalPage';
import RMFSumSub from './components/RMFSumSub/RMFSumSub';
import RMFSummaryScreen from './components/RMFSummaryScreen/RMFSummaryScreen';
import RMFSummaryScreenUSPA from './components/RMFSummaryScreenUSPA/RMFSummaryScreenUSPA';
import RMFTermsOfService from './components/RMFTermsOfService/RMFTermsOfService';
import RMFUSPAFinishScreen from './components/RMFUSPAFinishScreen/RMFUSPAFinishScreen';
import RMFValidationError from './components/RMFValidationError/RMFValidationError';
import RMFVerification from './components/RMFVerification/RMFVerification';
import RMFVerificationUSPA from './components/RMFVerificationUSPA/RMFVerificationUSPA';
import useRmfFlow from './hooks/useRmfFlow';
import useRmfGuards from './hooks/useRmfGuards';
import useRmfServices from './hooks/useRmfServices';

const RMF: React.FC = () => {
  const flow = useRmfFlow();
  const guards = useRmfGuards();
  const services = useRmfServices();

  return (
    <TrackingContext.Provider value={{ category: TrackingCategory.RMF }}>
      <WizardGroup name={getDisplayName(RMF)} flow={flow} services={services} guards={guards}>
        <BonusOffer />
        <RMFSumSub />
        <RMFLegalName />
        <RMFSSN />
        <RMFSSNConfirmation />
        <RMFGender />
        <RMFFiscalCode />
        <RMFPlaceOfBirth />
        <RMFAddress />
        <RMFDocumentation />
        <RMFCitizenship />
        <RMFCompleted />
        <RMFCompletedDK />
        <RMFDOB />
        <RMFOccupationPEP />
        <RMFPhone />
        <RMFPhoneVerification />
        <RMFOccupation />
        <RMFIdentityVerification />
        <RMFDepositLimit />
        <RMFValidationError />
        <RMFPlayingTimeLimit />
        <RMFLossLimit />
        <RMFAccumulatedBuyInLimit />
        <RMFPokerTimeLimit />
        <RMFKBA />
        <RMFAutomaticWithdrawalLimit />
        <RMFPlayerFundsProtection />
        <RMFPendingVerification />
        <RMFSummaryScreen />
        <RMFSummaryScreenUSPA />
        <RMFVerification />
        <RMFVerificationUSPA />
        <RMFSecurityQuestions />
        <SignupOffer />
        <RMFTermsOfService />
        <RMFCrossOperatorDepositLimit />
        <RMFBankDetails />
        <RMFEKYCSuccess />
        <RMFStandaloneFinalPage />
        <RMFResult />
        <RMFUSPAFinishScreen />
      </WizardGroup>
    </TrackingContext.Provider>
  );
};

RMF.displayName = 'RMF';

export default RMF;
